import { Component, Inject, OnInit } from '@angular/core';
import { RouterService } from '../../utility/router-service';
import { HttpService } from '../../utility/http-service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-client-icon-editor',
  standalone: false,
  
  templateUrl: './client-icon-editor.component.html',
  styleUrl: './client-icon-editor.component.css'
})
export class ClientIconEditorComponent implements OnInit {

  public icon: string = "";
  public width: number = 0;
  public height: number = 0;
  constructor(public dialogRef: MatDialogRef<string>,
    @Inject(MAT_DIALOG_DATA) public model: string,
    private router: RouterService, private http: HttpService) {

  }
  ngOnInit(): void {

    this.http.get<any>(`ClientSettings/GetIcon?id=${this.model}`, (p: any) => {
      this.icon = p.iconText,
        this.width = p.width,
        this.height = p.height
    });
  }

  onFileSelected(event:any) {

    const file: File = event.target.files[0];

    if (file) {
      const formData = new FormData();

      formData.append("file", file);
      formData.append("id", this.model);
      this.http.post("ClientSettings/UploadImage", () => this.router.reloadPage(), null, formData);
    }

  }
}
